import React from 'react';
import {
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

const FeatureChecklistTab = ({ items = [] }) => (
  <Stack spacing={2}>
    {items.map((item) => (
      <Paper key={item.id} elevation={0} sx={{ p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          <Box>
            <Typography variant="subtitle1">{item.title}</Typography>
            <Typography variant="body2" color="text.secondary">{item.description}</Typography>
          </Box>
          <Chip
            label={item.status?.replace('-', ' ') || 'planned'}
            color={item.status === 'complete' ? 'success' : item.status === 'in-progress' ? 'warning' : 'default'}
          />
        </Stack>
      </Paper>
    ))}
    {!items.length && (
      <Typography variant="body2" color="text.secondary">
        No feature recommendations recorded yet.
      </Typography>
    )}
  </Stack>
);

export default FeatureChecklistTab;
